/* eslint-disable camelcase */
import React, { Fragment } from 'react';
import { StyleSheet, css } from 'aphrodite';
import CircularProgress from '@material-ui/core/CircularProgress';
import moment from 'moment-timezone'

import { ApiHelper } from './ApiHelper';
import { Helper } from '../helpers/Helper';
import { AppTheme } from '../../styles/AppTheme';
import { AppStyles } from '../../styles/AppTheme';
import Tooltip from '@material-ui/core/Tooltip';
import { Link } from 'react-router-dom';
import MenuItem from '@material-ui/core/MenuItem';
import Chip from '@material-ui/core/Chip';
import { AppConfig } from '../../AppConfig';
import { AppButton } from '../components/AppButton';
import { Controller } from '../Controller';
import { Badge, IconButton } from '@material-ui/core';
import { AppHelper } from '../../helpers/AppHelper';
import { StaffHelper } from './StaffHelper';
import { CdpHelper } from '../../helpers/CdpHelper';
const ERROR_MSG = Helper.getString('defaultApiErrMsg')

export class UiHelper {

  static itemIdContainer(current) {
    return (
      <div>
        <span className={css(Styles.spanValue)}>{current.slug}</span>
        <br />
        <span className={css(Styles.spanValue)}>{current.id}</span>
      </div>
    )
  }

  static itemTitleImage(current) {
    return (
      <div className={css(Styles.spanContainer)}>
        <div className={css(Styles.spanImgContainer)}>
          {current.image ?
            <img src={current.image} className={css(Styles.imageContent)} />
            :
            <i className='material-icons-outlined' style={{ fontSize: 40, color: 'lightgray' }}>image</i>
          }
        </div>
        <div className={css(Styles.spanTextContainer)}>
          <span className={css(Styles.itemValue)}>{current.title}</span>
        </div>
      </div>
    )
  }

  static itemImage(current) {
    const image = current.imageLink || current.image
    return (
      <div className={css(Styles.spanContainer)}>
        <div className={css(Styles.spanImgContainer)}>
          {image ?
            <img src={image} className={css(Styles.imageContent)} />
            :
            <i className='material-icons-outlined' style={{ fontSize: 40, color: 'lightgray' }}>image</i>
          }
        </div>
      </div>
    )
  }

  static itemStatusContainer(current) {
    return (
      <div className={css(Styles.statusOuterContainer)}>
        <p className={current.state === 'LIVE' ? css(Styles.statusTitle) : css(Styles.statusTitle, Styles.statusTitleStyle)}>{current.state || ''.toLowerCase()}</p>
        <div>
          {current.likeCount !== undefined &&
            <div className={css(Styles.countContainer)}>
              <div className={css(Styles.imageContainer)}>
                <i className='material-icons-outlined' style={{ fontSize: 20, color: AppTheme.primaryColor }}>thumb_up</i>
              </div>
              <p className={css(Styles.statusValue)}>{current.likeCount || 0}</p>
            </div>
          }
          {current.buyCount !== undefined &&
            <div className={css(Styles.countContainer, Styles.countSecondContainer)}>
              <div className={css(Styles.imageContainer)}>
                <i className='material-icons-outlined' style={{ fontSize: 20, color: AppTheme.primaryColor }}>shopping_basket</i>

              </div>
              <p className={css(Styles.statusValue)}>{current.buyCount || 0}</p>
            </div>
          }
        </div>
      </div>
    )
  }

  static itemDetails(current) {
    return (
      <div className={css(Styles.spanContainer)}>
        <div className={css(Styles.spanImgContainer)}>
          {(current.variantItems && current.variantItems[0].image || current.image) ?
            <img src={current.imageLink || current.image || current.variantItems[0].image}
              className={css(Styles.imageContent)} />
            :
            <i className='material-icons-outlined' style={{ fontSize: 40, color: 'lightgray' }}>image</i>
          }
        </div>
        <div>
          <span className={css(Styles.itemValue)}>{current.title}</span>
          <br />
          <div className={css(Styles.slugSmContainer)}>
            {current.includeInSitemap && current.includeInSitemap === 'YES' &&
             <span className={css(Styles.itemValue, Styles.line2)}>
               <Chip size='small' label={Helper.getString('sitemapIncluded')} style={{ backgroundColor: 'lightgray', color: 'black', fontSize: 8, height: 20 }} />
             </span>
            }
            <span className={css(Styles.itemValue, Styles.line2)}>
              {current.slug} {current.badge && <Chip size='small' label={current.badge} style={{ backgroundColor: 'lightgray', color: 'black', fontSize: 8, height: 20 }} />}
            </span>
          </div>
        </div>
      </div>
    )
  }

  static itemTitleId(current) {
    return (
      <div>
        <span className={css(Styles.spanValue)}>{current.title}</span>
        <br />
        <span className={css(Styles.itemValue, Styles.line2)}>{current.slug || current.id}</span>
      </div>
    )
  }

  static chipLive(label) {
    if (label === 'LIVE') return UiHelper.chipPos(label)
    else return ''
  }

  static chipFeatured(label) {
    if (label === 'FEATURED') return UiHelper.chipPos(label)
    else return ''
  }

  static chipHome(label) {
    if (label === 'HOME') return UiHelper.chipPos(label)
    else return ''
  }

  static chip(label) {
    if (!label) return ''
    return (
      <Chip size='small' label={label} />
    )
  }

  static chipPos(label) {
    if (!label) return ''
    return (
      <Chip size='small' label={label} style={{ backgroundColor: '#77DD77', color: 'black' }} />
    )
  }

  static loadingView() {
    return (
      <div className={css(Styles.container)}>
        <CircularProgress size={48} className={css(Styles.progress)} />
      </div>
    )
  }

  static itemLoadingView(size) {
    return (
      <CircularProgress size={size || 24} className={css(Styles.progress)} />
    )
  }

  static itemLoadingViewButton(size, options) {
    return (
      <IconButton className={options && options.buttonStyles && css(options.buttonStyles)}>
        <CircularProgress size={size || 24} className={(options && options.progressIconStyles) ? css([Styles.progress, options.progressIconStyles]) : css(Styles.progress)} />
      </IconButton>
    )
  }

  static errorView(caller) {
    if (AppConfig.CUSTOM_STYLE) {
      return UiHelper.customErrorView(caller)
    } else {
      return (
        <div className='pageError'>
          {caller.state.errMsg || ERROR_MSG}
        </div>
      )
    }
  }

  static goToHome() {
    const path = Controller.get().roleHelper().getHome()
    window.location.href = path
  }

  static customErrorView(caller) {
    return (
      <div className='pageError'>
        <div className={css(Styles.customEmptyContainer)}>
          <div className={css(Styles.customImageContainer)}>
            <img src={require('../../assets/images/error.svg')} className={css(Styles.image)} />
          </div>
          <p className={css(Styles.customText)}>{caller.state.errMsg || Helper.getString('defaultApiErrMsg')}</p>
          <AppButton
            buttonText={Helper.getString('browseHome')}
            onClick={() => UiHelper.goToHome()}
          />
        </div>
      </div>
    )
  }

  static staticErrorView(caller) {
    return (
      <div className={css(Styles.errorContainer)}>
        <div className={css(Styles.errImageContainer)}>
          <img src={require('../../assets/images/404.svg')} className={css(Styles.image)} />
        </div>
        <p className={css(Styles.nfMiddle)}>{Helper.getString('serviceErr')}</p>
      </div>
    )
  }

  static componentLoadingView(pageDialogMode = false) {
    if (AppConfig.CUSTOM_STYLE) {
      return UiHelper.customLoadingView(pageDialogMode)
    } else {
      return (
        <div className={css(Styles.container)}>
          <CircularProgress size={48} className={css(Styles.progress)} />
        </div>
      )
    }
  }

  static customLoadingView(pageDialogMode = false) {
    const containerStyles = pageDialogMode ? css(Styles.container2, Styles.container2PageDialog) : css(Styles.container2)
    return (
      <div className={containerStyles}>
        <div className={css(Styles.loaderContainer)}>
          <div className='loader' />
          <div className={css(Styles.loaderImageContainer)}>
            <img src={require('../../assets/images/loading.png')} className={css(Styles.image)} />
          </div>
        </div>

        <p className={css(Styles.customText)}>{Helper.getString('loadingText')}</p>
      </div>
    )
  }

  static contentLoadingView() {
    return (
      <div className={css(Styles.container2, Styles.transparentLoadingViewContainer)}>
        <div className={css(Styles.loaderContainer)}>
          <div className='loader' />
          <div className={css(Styles.loaderImageContainer)}>
            <img src={require('../../assets/images/loading.png')} className={css(Styles.image)} />
          </div>
        </div>

        <p className={css(Styles.customText)}>{Helper.getString('loadingText')}</p>
      </div>
    )
  }

  static contentLoadingViewOverlay() {
    return (<div className={css(Styles.loadingViewOverlay)}></div>)
  }

  static inPlaceContentLoadingView() {
    return (
      <div className={css(Styles.container2, Styles.inPlaceContentLoadingViewContainer)}>
        <div className={css(Styles.loaderContainer)}>
          <div className='loader' />
          <div className={css(Styles.loaderImageContainer)}>
            <img src={require('../../assets/images/loading.png')} className={css(Styles.image)} />
          </div>
        </div>

        <p className={css(Styles.customText)}>{Helper.getString('loadingText')}</p>
      </div>
    )
  }


  static emptyView(msg) {
    if (AppConfig.CUSTOM_STYLE) {
      return UiHelper.customEmptyView(msg)
    } else {
      return (
        <div className={css(Styles.emptyContainer)}>
          <p>{msg || Helper.getString('emptyMsg')}</p>
        </div>
      )
    }
  }

  static customEmptyView(msg) {
    return (
      <div className={css(Styles.customEmptyContainer)}>
        <div className={css(Styles.customImageContainer)}>
          <img src={require('../../assets/images/empty.svg')} className={css(Styles.image)} />
        </div>
        <p className={css(Styles.customText)}>{msg || Helper.getString('emptyMsg')}</p>
      </div>
    )
  }

  static customErrorViewWithRefresh(error) {
    if(error) {
      return (
        <div className={css(Styles.customEmptyContainer)}>
          <div className={css(Styles.customImageContainer)}>
            {error.image && <img src={error.image} className={css(Styles.image)} />}
          </div>
          <p className={css(Styles.customText)}>{error.message || Helper.getString('emptyMsg')}</p>
          {(error.buttonText || error.buttonIcon) && <AppButton
            onClick={error.action}
            icon={error.buttonIcon}
            iconContainerStyle={Styles.iconContainerStyle}
            buttonText={error.buttonText}
          />}
        </div>
      )
    }
  }

  static componentErrorView(caller) {
    return (
      <div className={css(Styles.container)}>
        <p className={css(Styles.error)}>{caller.state.errMsg || ERROR_MSG}</p>
      </div>
    )
  }

  static actionButton(item) {
    const disabled = item.disabled
    return (
      <Tooltip title={(item.tooltip && item.tooltip !== '') ? item.tooltip : ''} placement='top-start' key={item.current && item.current.id}>
        <div
          className={css(Styles.actionMenuItem)}
          onClick={disabled ? undefined : item.action}
          key={item.key}
          style={disabled ? { cursor: 'not-allowed' } : undefined}
        >
          {item.title &&
            <p className={css(Styles.actionMenuText)} style={disabled ? { color: '#AAAAAA' } : undefined}>{item.title}</p>
          }
          {item.icon &&
            <i className='material-icons-outlined' style={{ fontSize: 22, color: disabled ? '#AAAAAA' : AppTheme.primaryColor }}>{item.icon}</i>
          }
        </div>
      </Tooltip>
    )
  }

  static buttonEdit(caller, current, title, options) {
    return (
      <Tooltip title={title || 'Edit'} placement='top-start' key={current.id + 'editTT'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons-outlined' onClick={() => caller.openModalForEdit(current)}>{options && options.icon || 'edit'}</i>
        </span>
      </Tooltip>
    )
  }

  static buttonInfo(caller, current, title) {
    return (
      <Tooltip title={title || 'Info'} placement='top-start' key={current.id + 'infoTT'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons-outlined' onClick={() => caller.openModalForInfo(current)}>info</i>
        </span>
      </Tooltip>
    )
  }

  static buttonDelete(caller, current) {
    return (
      <Tooltip title='Delete' placement='top-start' key={current.id + 'deleteTT'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons-outlined' onClick={() => caller.openModalForDelete(current)}>delete</i>
        </span>
      </Tooltip>
    )
  }

  static buttonRefresh(caller, current) {
    const isMobileView = Helper.isMobileView()
    return (<Tooltip title={'Refresh'} classes={{ popper: css(Styles.tooltip) }} arrow>
      <IconButton onClick={() => caller.handleRefreshButtonClick()}>
        <i className='material-icons-outlined' style={{ fontSize: UiHelper.itemLoadingView(isMobileView ? 12 : 20), color: AppTheme.primaryColor }}>refresh</i>
      </IconButton>
    </Tooltip>)
  }


  static buttonOrderChange(current, orderChangePayload, order) {
    const {index, items, toolTipUp, toolTipDown, orderUp, orderDown, fetchState, currentOrderChangeIndex } = orderChangePayload

    if(fetchState === ApiHelper.State.LOADING && currentOrderChangeIndex === index) {
      return (
        <div className={css(Styles.orderChangeBtnContainer)}>
          <CircularProgress size={20} className={css(Styles.progress)} />
        </div>
      )
    }

    return (
      <div className={css(Styles.orderChangeBtnContainer)}>
        { <Tooltip title={toolTipUp || Helper.getString('moveUp')} placement='top-start' key={current.id + Helper.getString('moveUp')}>
          <span className={(index > 0) ? css(AppStyles.entityTableLinkIcon, Styles.orderChangeBtn) : css(AppStyles.entityTableLinkIcon, Styles.orderChangeBtnDisabled)}>
            <i className='material-icons-outlined' onClick={() =>
              orderUp(current, items, index)}>keyboard_arrow_up</i>
          </span>
        </Tooltip>}
        <span className={css(Styles.orderText)}>{order}</span>
        {  <Tooltip title={toolTipDown || Helper.getString('moveDown')} placement='top-start' key={current.id + Helper.getString('moveDown')}>
          <span className={(index < items.length - 1) ? css(AppStyles.entityTableLinkIcon, Styles.orderChangeBtn) : css(AppStyles.entityTableLinkIcon, Styles.orderChangeBtnDisabled)}>
            <i className='material-icons-outlined' onClick={() =>
              orderDown(current, items, index)}>keyboard_arrow_down</i>
          </span>
        </Tooltip>}
      </div>
    )
  }

  static buttonSEO(caller, current) {
    return (
      <Tooltip title='SEO' placement='top-start' key={current.id + 'SEOTT'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons-outlined' onClick={() => caller.openModalForSEO(current)}>content_paste_search</i>
        </span>
      </Tooltip>
    )
  }

  static buttonOpenItemsInCat(caller, current) {
    return (
      <Link to={caller.baseRoute() + '/cats/' + current.id + '/items'} key={current.id + '-items'} >
        <Tooltip title={Helper.getString('items')} placement='top-start'>
          <span className={css(AppStyles.entityTableLinkIcon)}>
            <i className='material-icons-outlined'>layers</i>
          </span>
        </Tooltip>
      </Link>
    )
  }

  static buttonOpenItemsInCCat(caller, current) {
    return (
      <Link to={caller.baseRoute() + '/cats/' + current.id + '/items'} key={current.id + '-items'} >
        <Tooltip title={Helper.getString('items')} placement='top-start'>
          <span className={css(AppStyles.entityTableLinkIcon)}>
            <i className='material-icons-outlined'>layers</i>
          </span>
        </Tooltip>
      </Link>
    )
  }

  static buttonOpenBlogsInTag(caller, current) {
    return (
      <Link to={caller.baseRoute() + '/btags/' + current.id + '/blogs'} key={current.id + '-blogs'}>
        <Tooltip title={Helper.getString('blogs')} placement='top-start'>
          <span className={css(AppStyles.entityTableLinkIcon)}>
            <i className='material-icons-outlined'>layers</i>
          </span>
        </Tooltip>
      </Link>
    )
  }

  static buttonOpenBlog(caller, current) {
    return (
      <Link to={this.baseRoute(current.orgId) + '/blogs/' + current.id} key={current.id}>
        <Tooltip title='Edit details' placement='top-start'>
          <span className={css(AppStyles.entityTableLinkIcon)}><i className='material-icons-outlined'>link</i></span>
        </Tooltip>
      </Link>
    )
  }

  static buttonOpenBlogContent(caller, current) {
    return (
      <Link to={this.baseRoute(current.orgId) + '/blogs/content/' + current.id} key={current.id}>
        <Tooltip title='Edit content' placement='top-start'>
          <span className={css(AppStyles.entityTableLinkIcon)}><i className='material-icons-outlined'>text_format</i></span>
        </Tooltip>
      </Link>
    )
  }

  static buttonOpenProduct(caller, current) {
    return (
      <Link to={this.baseRoute(current.orgId) + '/products/' + current.id} key={current.id} >
        <Tooltip title='Open' placement='top-start'>
          <span className={css(AppStyles.entityTableLinkIcon)}><i className='material-icons-outlined'>link</i></span>
        </Tooltip>
      </Link>
    )
  }

  static buttonOpenCourse(caller, current) {
    return (
      <Link to={this.baseRoute(current.orgId) + '/courses/' + current.courseId} key={current.courseId} >
        <Tooltip title='Open' placement='top-start'>
          <span className={css(AppStyles.entityTableLinkIcon)}><i className='material-icons-outlined'>link</i></span>
        </Tooltip>
      </Link>
    )
  }

  static buttonEditMenuItem(caller, current) {
    return (
      <MenuItem className={css(AppStyles.menuItem)}>
        <div key={current.id + 'editTT'} onClick={() => caller.openModalForEdit(current)} className={css(AppStyles.menuContainer)}>
          <span className={css(AppStyles.entityTableLinkIcon, AppStyles.entityTableLinkIconMenu)}>
            <i className='material-icons-outlined'>edit</i>
          </span>
          <p className={css(AppStyles.titleContainer)}>Edit</p>
        </div>
      </MenuItem>
    )
  }

  static buttonDeleteMenuItem(caller, current) {
    return (
      <MenuItem className={css(AppStyles.menuItem)}>
        <div key={current.id + 'deleteTT'} onClick={() => caller.openModalForDelete(current)} className={css(AppStyles.menuContainer)}>
          <span className={css(AppStyles.entityTableLinkIcon, AppStyles.entityTableLinkIconMenu)}>
            <i className='material-icons-outlined'>delete</i>
          </span>
          <p className={css(AppStyles.titleContainer)}>Delete</p>
        </div>
      </MenuItem>
    )
  }

  static attachTeamToFieldLabel(fieldDef, key, subOrgs) {
    if(fieldDef && key) {
      const field = Helper.getField(fieldDef, key)
      if(field && field.options) {
        field.options.forEach((option)=>{
          if(option && option.key && typeof option.key === 'string' && option.key.indexOf('-') !== -1) {
            const orgUnitId = option.key.slice(0, option.key.lastIndexOf('-'))
            const {orgId, subOrgId} = AppHelper.parseOrgUnitId(orgUnitId)
            if(orgUnitId && subOrgs) {
              const subOrg = subOrgs.find((obj) => {
                return obj && obj.id === subOrgId
              })
              if(subOrg) {
                option.text = `${option.text} (${subOrg.title})`
              }
            }
          }
        })
      }
    }
  }

  static filterFieldForMainOrgOptions(fieldDef, key, subOrgs, staffUsers, orgId) {
    if(fieldDef && key) {
      const field = Helper.getField(fieldDef, key)
      if(field && field.options) {
        const mainOrgUserIds = StaffHelper.userIdsWithOrgAccess(staffUsers, orgId)
        field.options = field.options.filter((option)=>{
          if(option && option.key) {
            if (typeof option.key !== 'string' || option.key.indexOf('-') === -1) {
              if (!orgId || !Array.isArray(staffUsers)) {
                return true
              }
              return mainOrgUserIds.has(option.key)
            }
            const orgUnitId = option.key.slice(0, option.key.lastIndexOf('-'))
            const {orgId: _orgId, subOrgId} = AppHelper.parseOrgUnitId(orgUnitId)
            if(orgUnitId && subOrgs) {
              const subOrg = subOrgs.find((obj) => {
                return obj && obj.id === subOrgId
              })
              if(subOrg) {
                return false
              }
            }
            return true
          }
        })
      }
    }
  }

  static populateOptions(formDefinition, apiResult, key) {
    const options = []
    for (const d of apiResult.items) {
      options.push({
        key: d.id || d.userId,
        text: d.title || Helper.formatName(d)
      })
    }
    for (const field of formDefinition.steps[0].fields) {
      if (field.key === key) {
        field.options = options
      }
    }
  }

  static removeField (fields,fieldKey) {
    const index = fields.findIndex(i => i.key === fieldKey);
    if (index >= 0) {
      fields.splice(index, 1);
    }
  }

  static modifyNuberOfRowsRichtext (fields,rows) {
    for (let index = 0; index < fields.length; index++) {
      const field = fields[index]
      if(field.type === 'rich_text') {
        field.rows = rows
      }
    }
  }

  static baseRoute(orgId) {
    return orgId !== 'PRODUCT' ? '/admin/orgs/' + orgId : '/admin'
  }

  static fieldDefResolve(options) {
    console.log('fieldDefResolve:', options)
    const { def, values, key } = options
    let resolved = values[key]
    if (!def) return resolved
    def.steps[0].fields.forEach(field => {
      if (field.key !== key) return
      if (!field.options) return
      const optionsByKey = Helper.itemsToMap(field.options, 'key')
      const value = values[key]
      if (value) {
        if (field.type === 'radio') {
          const option = optionsByKey[value]
          if (option) {
            resolved = option.label || option.text
            return
          }
        } else if (field.type === 'check_box') {
          const resolves = []
          value.forEach(v => {
            const option = optionsByKey[v]
            if (option) resolves.push(option.label || option.text)
          })
          if (resolves.length > 0) {
            resolved = resolves.join(', ')
            return
          }
        }
      }
    })
    return resolved
  }

  static fieldDefDeleteField(fieldDef, key) {
    if (fieldDef && Array.isArray(fieldDef.steps) && fieldDef.steps.length > 0 && Array.isArray(fieldDef.steps[0].fields)) {
      fieldDef.steps[0].fields = fieldDef.steps[0].fields.filter(f => f.key !== key)
    }
  }

  static renderImg = (options) => {
    let imgUrl = ''
    let icon = ''
    switch (options.key) {
    case 'file':
      try {
        imgUrl = require('../../assets/images/document-img.svg')
      } catch (err) {
        imgUrl = null
        icon = 'file_open'
      }
      break
    case 'drawerMenu':
      if (options.drawerIsOpen) {
        try {
          imgUrl = require('../../assets/images/drawer-button-close.svg')
        } catch (err) {
          imgUrl = null
          icon = 'menu_open'
        }
      } else {
        try {
          imgUrl = require('../../assets/images/drawer-button-open.svg')
        } catch (err) {
          imgUrl = null
          icon = 'menu'
        }
      }
      break
    case 'drawerClose':
      try {
        imgUrl = require('../../assets/images/drawer-button-close.svg')
      } catch (err) {
        imgUrl = null
        icon = 'menu_open'
      }
      break
    case 'drawerOpen':
      try {
        imgUrl = require('../../assets/images/drawer-button-open.svg')
      } catch (err) {
        imgUrl = null
        icon = 'menu'
      }
      break
    case 'docUpload':
      try {
        imgUrl = require('../../assets/images/img-uploader.svg')
      } catch (err) {
        imgUrl = null
        icon = 'file_upload'
      }
      break
    case 'imgUpload':
      try {
        imgUrl = require('../../assets/images/export.svg')
      } catch (err) {
        imgUrl = null
        icon = 'file_upload'
      }
      break
    default:
      return ''
    }
    if (imgUrl) {
      return <img src={imgUrl} className={css(Styles.imageContent)} />
    } else {
      return <i className='material-icons-outlined' style={{ fontSize: options.size || 24, color: AppTheme.primaryColor }}>{icon}</i>
    }
  }

  static renderTransparentTile = () => {
    return (
      <div className={css(Styles.transparentOuterContainer)}>
        <div className={css(Styles.transparentInnerContainer)}>
          <div className={css(Styles.checkBox1)}></div>
          <div className={css(Styles.checkBox2)}></div>
        </div>
        <div className={css(Styles.transparentInnerContainer)}>
          <div className={css(Styles.checkBox2)}></div>
          <div className={css(Styles.checkBox1)}></div>
        </div>
      </div>
    )
  }

  static renderTransparentTileBycolorCode = (colorCode) => {
    return colorCode === AppConfig.TRANSPARENT_COLOR_CODE ? UiHelper.renderTransparentTile() : ''
  }

  static renderDaysInWeek = (selectedDays) => {
    const daysOfWeekLong = Helper.getDaysOfWeekLong();
    return(
      <div className={css(Styles.weekDaysContainer)}>
        {daysOfWeekLong.map((day) => (
          <div
            key={day}
            className={css(Styles.dayCell,selectedDays.includes(day) ? Styles.activeDayCell : Styles.normalDayCell )}
          >
            {Helper.getShortDayFromLong(day)}
          </div>
        ))}
      </div>
    )
  }

  static getSequencesFieldDef(crmSequences, crmInboxes, isBulkEnrol) {
    const sequencesFieldDef = {
      steps: [
        {
          fields: [
            {
              key: 'campaignId',
              type: 'radio',
              label: 'Drip Sequence',
              hint: 'Select drip sequence',
              options: [],
              v_required: { value: true, err: 'Select drip sequence' },
              placement: 'left'
            },
            {
              key: 'inboxId',
              type: isBulkEnrol ? 'check_box' : 'radio',
              label: 'Sender Inbox',
              hint: 'Select sender inbox',
              options: [],
              v_required: { value: true, err: 'Select sender inbox' },
              placement: 'right'
            },
            {
              key: 'startDate',
              type: 'dateTime',
              label: 'Start date',
              hint: 'Select start date',
              v_required: { value: false, err: 'Select start date' },
              placement: 'left',
              advanced: true,
            },
          ]
        }
      ]
    }
    const activeSequences = (crmSequences || []).filter(s => s && s.state !== 'DELETED')
    UiHelper.populateOptions(sequencesFieldDef, {items: activeSequences}, 'campaignId')
    const inboxField = sequencesFieldDef.steps[0].fields.find(f => f.key === 'inboxId')
    // Lazy require avoids circular import with CRMHelper (which imports UiHelper)
    const { CRMHelper } = require('../../helpers/CRMHelper')
    const eligibleInboxes = CRMHelper.filterInboxes(crmInboxes, isBulkEnrol ? 'enrolBulk' : 'enrolSingle')
    inboxField.options = CRMHelper.toInboxSelectOptions(eligibleInboxes)
    Helper.populateFormDefinitionValues(sequencesFieldDef, {
      campaignId: '',
      inboxId: inboxField.defaultValue || '',
      startDate: Helper.currentTs(),
    })
    return sequencesFieldDef
  }

  static openModalForSequences(items, crmSequences, crmInboxes) {
    if(!items) {
      return null
    }

    const isBulkEnrol = Array.isArray(items)
    this.apiData = {
      orgId: this.orgId,
      userIds: Array.isArray(items) ? items.map(u => u.userId) : [items.userId],
      staffUserId: this.staffUserId,
      seqEnrolmentNextStepIndex: 0,
      __isBulkEnrol: isBulkEnrol,
    }
    this.formDefinition = UiHelper.getSequencesFieldDef(crmSequences, crmInboxes, isBulkEnrol)
    this.formDefinition.formType = 'edit'
    this.formDefinition.ctaButtonText = 'Next'
    this.formDefinition.title = `Enroll ${this.apiData.userIds.length} ${this.apiData.userIds.length === 1 ? 'contact' : 'contacts'}`
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath2({
        ms: AppConfig.CDP_MS.ENDPOINT,
        paths: ['miscs', 'create-seq-enrolments'],
        queryParams: { orgId: this.orgId }
      }),
      modalOpen: true
    });
  }

  static openModalForSeqEnrolmentCalendar(firstEnrolmentStartDate, lastEnrolmentEndDate, apiData) {
    this.apiData = apiData
    const fieldDef = {
      steps: [
        {
          fields: [
            {
              key: 'firstEnrolmentStartDate',
              type: 'dateTime',
              label: 'First step will send by',
              v_required: { value: false },
              placement: 'left',
              value: Helper.getNextHourTs(firstEnrolmentStartDate),
            },
            {
              key: 'lastEnrolmentEndDate',
              type: 'dateTime',
              label: 'All steps will complete by',
              v_required: { value: false },
              placement: 'right',
              value: Helper.getNextHourTs(lastEnrolmentEndDate),
            },
          ]
        }
      ],
      disableAlwaysFormFields: ['firstEnrolmentStartDate', 'lastEnrolmentEndDate'],
    }
    this.formDefinition = fieldDef
    this.formDefinition.formType = 'add'
    this.formDefinition.ctaButtonText = 'Next'
    this.formDefinition.title = `Review enrolment calendar for ${apiData.userIds.length} contact${apiData.userIds.length === 1 ? '' : 's'}`
    this.setState({
      modalOpen: true
    });
  }

  static openModalForSeqEnrolmentStep(stepIndex, steps, emailSignatureRichText, apiData) {
    this.apiData = apiData
    const step = steps[stepIndex]
    this.apiData.step = step
    const emailTemplate = JSON.parse(JSON.stringify(this.crmEmailTemplates.find(t => t.id === step.stepEmailTemplateId)))
    if (step.stepIncludeEmailSignature && step.stepIncludeEmailSignature === 'ENABLED') {
      emailTemplate.bodyRichText = Helper.mergeRichText(emailTemplate.bodyRichText, emailSignatureRichText)
    }
    const fieldDef = JSON.parse(JSON.stringify(this.crmEmailTemplateFieldDef))
    fieldDef.steps[0].fields = fieldDef.steps[0].fields.filter(f => ['subject', 'bodyRichText', 'attachment'].includes(f.key))
    const bodyRichTextField = fieldDef.steps[0].fields.find(f => f.key === 'bodyRichText')
    if (bodyRichTextField) {
      const { AppUiHelper } = require('../../helpers/AppUiHelper')
      bodyRichTextField.variablePicker = {
        title: 'Custom Fields',
        options: AppUiHelper.getEmailTemplateVariables(this.fieldDef),
      }
    }
    Helper.populateFormDefinitionValues(fieldDef, emailTemplate)
    this.formDefinition = fieldDef
    this.formDefinition.formType = 'add'
    this.formDefinition.ctaButtonText = stepIndex === steps.length - 1 ? 'Enroll' : 'Next'
    this.formDefinition.title = `Review step ${stepIndex + 1}/${steps.length}`
    this.formDefinition.disableAlwaysFormFields = apiData.__isBulkEnrol ? ['subject', 'bodyRichText', 'attachment'] : []
    this.setState({
      modalOpen: true
    });
  }

  static async customSubmitForSequences(options) {
    const { formType, formData, caller } = options

    const seqEnrolmentNextStepIndex = formData.seqEnrolmentNextStepIndex
    const subject = formData.subject
    const bodyRichText = formData.bodyRichText
    const attachment = formData.attachment
    const step = formData.step

    delete formData.seqEnrolmentNextStepIndex
    delete formData.subject
    delete formData.bodyRichText
    delete formData.attachment
    delete formData.step

    console.log('seqEnrolmentNextStepIndex: ', seqEnrolmentNextStepIndex)
    if (Number.isInteger(seqEnrolmentNextStepIndex)) {
      const apiData = {...formData}
      apiData.steps = seqEnrolmentNextStepIndex === -1 ? [] : (apiData.steps || [])
      if (step) {
        const subjectField = this.formDefinition.steps[0].fields.find(f => f.key === 'subject')
        const bodyRichTextField = this.formDefinition.steps[0].fields.find(f => f.key === 'bodyRichText')
        const attachmentField = this.formDefinition.steps[0].fields.find(f => f.key === 'attachment')
        if (subject && (subjectField.value !== subject || !apiData.__isBulkEnrol)) step.emailSubject = subject
        if (bodyRichText && (bodyRichTextField.value !== bodyRichText || !apiData.__isBulkEnrol)) step.emailBodyRichText = bodyRichText
        if (attachment && (attachmentField.value !== attachment || !apiData.__isBulkEnrol)) step.emailAttachment = attachment
        apiData.steps.push(step)
      }
      const sequence = this.crmSequences.find(s => s.id === apiData.campaignId)
      const steps = Object.values(sequence.steps).sort((a, b) => a.entityCreatedTs - b.entityCreatedTs)
      if (seqEnrolmentNextStepIndex === steps.length) {
        let isError = false
        await ApiHelper.callAwait({
          method: this.state.apiMethod,
          endPoint: this.state.apiEndPoint,
          jsonBody: apiData,
        }).catch(err => {
          const errMsg = err.message || 'The system encountered a problem. Please contact support.'
          caller.setState({
            fetchState: ApiHelper.State.ERROR,
            success: false,
            inProcess: false,
            errMsg,
            message: errMsg,
          })
          apiData.steps.pop()
          isError = true
        })
        if (isError) return
        this.setState({
          fetchState: ApiHelper.State.READY,
          inProcess: false,
          success: true,
          modalOpen: false,
          showToast: true,
          isErrorToast: false,
          toastMsg: (
            <span style={{ whiteSpace: 'nowrap' }}>
              {apiData.userIds.length} contacts enrolled into{' '}<a
                href={this.baseRoute() + `/campaigns/sequences/${apiData.campaignId}`}
                target='_blank'
                rel='noopener noreferrer'
                onClick={this.onToastCloseBtnClicked}
                style={{
                  color: 'inherit',
                  textDecoration: 'underline',
                  cursor: 'pointer'
                }}
              >
                {sequence.title}
              </a>
            </span>
          ),
          isToastCloseManual: true
        })
      } else if (seqEnrolmentNextStepIndex === -1) {
        let isError = false
        const enrolmentCalendar = await ApiHelper.callAwait({
          method: 'POST',
          ms: AppConfig.CDP_MS.ENDPOINT,
          paths: ['miscs', 'generate-enrolment-calendar'],
          jsonBody: apiData,
        }).catch(err => {
          const errMsg = err.message || 'The system encountered a problem. Please contact support.'
          caller.setState({
            fetchState: ApiHelper.State.ERROR,
            success: false,
            inProcess: false,
            errMsg,
            message: errMsg,
          })
          isError = true
        })
        if (isError) return
        let {enrolmentSlots} = enrolmentCalendar
        enrolmentSlots = enrolmentSlots || {}
        const firstUserId = apiData.userIds[0]
        const lastUserId = apiData.userIds[apiData.userIds.length - 1]
        const firstEnrolmentId = `${apiData.campaignId}-${firstUserId}`
        const lastEnrolmentId = `${apiData.campaignId}-${lastUserId}`
        const firstEnrolmentSlots = enrolmentSlots[firstEnrolmentId]
        const lastEnrolmentSlots = enrolmentSlots[lastEnrolmentId]
        const firstEnrolmentStepSlots = Object.values(firstEnrolmentSlots ? firstEnrolmentSlots.steps || {} : {})
        const lastEnrolmentStepSlots = Object.values(lastEnrolmentSlots ? lastEnrolmentSlots.steps || {} : {})
        const firstEnrolmentStartDate = firstEnrolmentStepSlots.length > 0 && !firstEnrolmentStepSlots.includes(-1) ? Math.min(...firstEnrolmentStepSlots) : -1
        const lastEnrolmentEndDate = lastEnrolmentStepSlots.length > 0 && !lastEnrolmentStepSlots.includes(-1) ? Math.max(...lastEnrolmentStepSlots) : -1
        if (firstEnrolmentStartDate === -1 || lastEnrolmentEndDate === -1) {
          const errMsg = 'Cannot enroll these contacts for the chosen inbox & campaign as they will take too long to complete. Try reducing the number of enrolments, changing the campaign sending window or using a different inbox.'
          caller.setState({
            fetchState: ApiHelper.State.ERROR,
            success: false,
            inProcess: false,
            errMsg,
            message: errMsg,
          })
          return
        } else {
          apiData.seqEnrolmentNextStepIndex = seqEnrolmentNextStepIndex + 1
          this.setState({ fetchState: ApiHelper.State.READY, modalOpen: false }, () => {
            UiHelper.openModalForSeqEnrolmentCalendar.call(this, firstEnrolmentStartDate, lastEnrolmentEndDate, apiData)
          })
        }
      } else {
        const fromInbox = !Array.isArray(apiData.inboxId) && this.crmInboxes.find(i => i.id === apiData.inboxId)
        const emailSignatureRichText = fromInbox && Helper.renderPlainText(fromInbox.signatureRichText) ? fromInbox.signatureRichText : ''
        apiData.seqEnrolmentNextStepIndex = seqEnrolmentNextStepIndex + 1
        this.setState({ fetchState: ApiHelper.State.READY, modalOpen: false }, () => {
          UiHelper.openModalForSeqEnrolmentStep.call(this, seqEnrolmentNextStepIndex, steps, emailSignatureRichText, apiData)
        })
      }
    }
  }
  static renderEmailClickTrail(emailClickTrail) {
    let out = ''
    emailClickTrail.forEach(clickData => {
      if (typeof clickData === 'string') {
        out = out + clickData + '\n\n'
      } else if (typeof clickData === 'object') {
        out = out + `${clickData.anchor} [${clickData.href}]\n\n`
      }
    })
    return out.trim()
  }
  static openModalForCreateCopy(current, type) {
    this.apiData = {
      orgId: this.orgId,
      id: current.id,
      type,
      _clientVersion: AppConfig.VERSION,
      // Leave key blank so BE auto-generates instead of colliding with the source
      ...(type === 'WORKFLOW' ? { workflowKey: '' } : {}),
    }
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath2({ ms: this.ms, paths: ['miscs', 'create-copy'], queryParams: {orgId: this.orgId} }),
    });
    this.formDefinition = {
      steps: [
        {
          fields: [
            {
              key: 'title',
              value: 'Copy of ' + current.title,
              type: 'edit_text',
              label: 'Title',
              v_required: { value: true, err: 'Provide title' },
              v_min: { value: 2, err: 'Title is too short (2 - 100)' },
              v_max: { value: 100, err: 'Title is too long (2 - 100)' },
              placement: 'left'
            },
          ]
        }
      ],
      title: 'Make a copy',
      ctaButtonText: 'Create',
      formType: 'add',
      _subType: 'create-copy',
    }
    this.setState({
      modalOpen: true
    });
  }

  static enrichCreditsModalDescription() {
    const learnMoreUrl = AppConfig.ENRICH_CREDITS_LEARN_MORE_URL
    return (
      <Fragment>
        {Helper.getString('enrichCreditsBalanceNotice')}{' '}
        <a
          href={learnMoreUrl}
          target='_blank'
          rel='noopener noreferrer'
          className={css(Styles.enrichCreditsLearnMoreLink)}
        >
          {Helper.getString('enrichCreditsLearnMore')}
        </a>
      </Fragment>
    )
  }

  static openModalForEnrich(items) {
    const enrichOptions = []
    if (AppHelper.isSettingEnabled(this.orgId, 'CRM_CONTACT_ENRICH_PHONE')) {
      enrichOptions.push({ key: 'PHONE', label: 'PHONE' })
    }
    if (AppHelper.isSettingEnabled(this.orgId, 'CRM_CONTACT_ENRICH')) {
      enrichOptions.push({ key: 'FRIENDLY NAME AND COMPANY NAME', label: 'FRIENDLY NAME AND COMPANY NAME' })
    }
    if (!enrichOptions.length) {
      return
    }
    const defaultValue = enrichOptions[0].key
    this.apiData = {
      orgId: this.orgId,
      userIds: Array.isArray(items) ? items.map(u => u.userId) : items.userId,
    }
    this.formDefinition = {
      steps: [
        {
          fields: [
            {
              key: 'enrichFields',
              type: 'radio',
              label: 'Fields',
              options: enrichOptions,
              defaultValue,
              v_required: { value: true, err: 'Select fields to enrich' },
              placement: 'left'
            },
          ]
        }
      ]
    }
    this.formDefinition.formType = 'add'
    this.formDefinition.ctaButtonText = 'Enrich'
    this.formDefinition.title = Array.isArray(this.apiData.userIds) ? `Enrich ${this.apiData.userIds.length} ${this.apiData.userIds.length === 1 ? 'contact' : 'contacts'}` : 'Enrich contact'
    if (AppHelper.isSettingEnabled(this.orgId, 'CRM_CONTACT_ENRICH_PHONE')) {
      this.formDefinition.description = UiHelper.enrichCreditsModalDescription()
      this.formDefinition.descriptionCondition = { key: 'enrichFields', value: 'PHONE' }
      this.formDefinition.customStyles = {
        modalDescriptionStyles: Styles.accountEnrichCreditsNotice,
      }
    }
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath2({
        ms: AppConfig.CDP_MS.ENDPOINT,
        paths: defaultValue === 'PHONE' ? ['miscs', 'enrich-crm-contact-phone'] : ['miscs', 'enrich-crm-contact'],
        queryParams: { orgId: this.orgId }
      }),
      modalOpen: true
    });
  }

  static customSubmitForEnrich(options) {
    const { formData, caller } = options
    const phoneEnrich = formData.enrichFields === 'PHONE'
    delete formData.enrichFields

    const apiMethod = 'POST'
    const apiEndpoint = ApiHelper.makeUrlPath2({
      ms: AppConfig.CDP_MS.ENDPOINT,
      paths: phoneEnrich ? ['miscs', 'enrich-crm-contact-phone'] : ['miscs', 'enrich-crm-contact'],
      queryParams: { orgId: this.orgId },
    })
    return ApiHelper.callAwait({
      method: apiMethod,
      endPoint: apiEndpoint,
      jsonBody: formData,
    }).then(response => {
      const isSyncEnrichResponse = phoneEnrich ? response.enrichPhoneResponse : response._enrichResponse
      if (isSyncEnrichResponse) {
        this.setState({
          success: true,
          message: Helper.getString('successful'),
          inProcess: false,
          showToast: phoneEnrich ? true : false,
          toastMsg: 'Phone number found and updated successfully.'
        })
        this.onCompleteAction({
          apiInvokeData: {
            method: apiMethod,
            endPoint: apiEndpoint,
            reqBody: formData,
            responseBody: response,
          }
        })
      } else {
        window.open(this.baseRoute() + '/jobscrm', '_self')
      }
    }).catch(err => {
      const errorMessage = Helper.getErrorMsg(err)
      caller.setState({
        fetchState: ApiHelper.State.ERROR,
        errMsg: errorMessage,
        success: false,
        message: errorMessage,
        inProcess: false
      })
    })
  }

  static openModalForEnrichAccount(items) {
    if (!AppHelper.isSettingEnabled(this.orgId, 'CRM_ACCOUNT_ENRICH')) {
      return
    }
    const accountIds = Array.isArray(items) ? items.map(a => a.id) : items.id
    this.apiData = {
      orgId: this.orgId,
      accountIds,
      _isAccountEnrich: true,
    }
    const enrichFieldsList = Helper.getString('accountEnrichFieldsList')
    this.formDefinition = {
      steps: [{
        fields: [{
          key: 'enrichAccountFields',
          type: 'edit_text',
          label: 'Fields to enrich',
          defaultValue: enrichFieldsList,
          placement: 'left',
          fullWidth: true,
          v_required: { value: false, err: '' },
        }],
      }],
      disableAlwaysFormFields: ['enrichAccountFields'],
    }
    this.formDefinition.formType = 'add'
    this.formDefinition.ctaButtonText = 'Enrich'
    const count = Array.isArray(accountIds) ? accountIds.length : 1
    this.formDefinition.title = count === 1 ? 'Enrich account' : `Enrich ${count} accounts`
    this.formDefinition.description = UiHelper.enrichCreditsModalDescription()
    this.formDefinition.customStyles = {
      modalDescriptionStyles: Styles.accountEnrichCreditsNotice,
    }
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath2({
        ms: AppConfig.CDP_MS.ENDPOINT,
        paths: ['miscs', 'enrich-account'],
        queryParams: { orgId: this.orgId },
      }),
      modalOpen: true,
    })
  }

  static customSubmitForEnrichAccount(options) {
    const { formData, caller } = options
    delete formData._isAccountEnrich
    delete formData.enrichAccountFields

    const apiMethod = 'POST'
    const apiEndpoint = ApiHelper.makeUrlPath2({
      ms: AppConfig.CDP_MS.ENDPOINT,
      paths: ['miscs', 'enrich-account'],
      queryParams: { orgId: this.orgId },
    })
    return ApiHelper.callAwait({
      method: apiMethod,
      endPoint: apiEndpoint,
      jsonBody: formData,
    }).then(response => {
      if (response.enrichAccountResponse) {
        this.setState({
          success: true,
          message: Helper.getString('successful'),
          inProcess: false,
          showToast: true,
          toastMsg: 'Account enriched successfully.',
        })
        this.onCompleteAction({
          apiInvokeData: {
            method: apiMethod,
            endPoint: apiEndpoint,
            reqBody: formData,
            responseBody: response,
          },
        })
      } else {
        window.open(this.baseRoute() + '/jobscrm', '_self')
      }
    }).catch(err => {
      const errorMessage = Helper.getErrorMsg(err)
      caller.setState({
        fetchState: ApiHelper.State.ERROR,
        errMsg: errorMessage,
        success: false,
        message: errorMessage,
        inProcess: false,
      })
    })
  }

  static openModalForUpdate(items) {
    this.apiData = {
      orgId: this.orgId,
      userIds: Array.isArray(items) ? items.map(u => u.userId) : items.userId,
      _bulkUpdate: true,
    }
    const showInternal = Helper.isShowInternal()
    const tagsField = JSON.parse(JSON.stringify(Helper.getField(this.fieldDef, 'tags')));
    if(tagsField && !showInternal) {
      tagsField.options = tagsField.options.filter(option => option.key !== 'INTERNAL');
    }
    const assigneeField = JSON.parse(JSON.stringify(Helper.getField(this.fieldDef, 'assignee')));
    if(assigneeField && assigneeField.options) {
      assigneeField.options.unshift({key:'unassigned', label:'[UNASSIGNED]'})
    }
    const timezoneField = JSON.parse(JSON.stringify(Helper.getField(this.fieldDef, 'timeZone')));
    const stateField = JSON.parse(JSON.stringify(Helper.getField(this.fieldDef, 'state')));
    if(stateField) {
      UiHelper.renameLeadStatusFieldOptions(stateField, this.orgId)
    }
    const subOrgIdField = Helper.getField(this.fieldDef, 'subOrgId');
    if(subOrgIdField && subOrgIdField.options) {
      subOrgIdField.options.unshift({key:'unassigned', label:'[UNASSIGNED]'})
    }
    const sourceField = JSON.parse(JSON.stringify(Helper.getField(this.fieldDef, 'source')));
    const customFields = CdpHelper.generateCustomFieldsForBulkUpdate(this.fieldDef, 'left')
    const customFieldKeys = customFields.map(f => f.key)
    const customFieldKeyMapping = {}
    this.fieldDef.steps[0].fields.forEach(f => {
      if (f._uiKey && customFieldKeys.includes(f._uiKey)) {
        customFieldKeyMapping[f._uiKey] = f.key
      }
    })
    this.apiData._customFieldKeys = customFieldKeys
    this.apiData._customFieldKeyMapping = customFieldKeyMapping
    const standardFields = [
      {
        key: 'tags',
        type: 'check_box',
        label: 'Additional Tags',
        tip: 'Add tags without changing any existing tags',
        options: tagsField ? tagsField.options : [],
        v_required: { value: false, err: 'Select tags to add' },
      },
      {...stateField, advanced: false, v_required: { value: false }},
      {...timezoneField, advanced: false},
      {
        key: 'assignee',
        type: 'radio',
        label: 'New Assignee',
        tip: 'Assign contact to a staff (leave blank for no change)',
        options: assigneeField ? assigneeField.options : [],
        v_required: { value: false, err: 'Select assignee' },
      },
    ]

    // Add subOrgId if teams enabled (keep it with assignee)
    if (!this.subOrgId && this.teamsEnabled && subOrgIdField) {
      standardFields.push({
        key: 'subOrgId',
        type: 'radio',
        label: 'New Team',
        tip: 'Assign contact to a team (leave blank for no change)',
        options: subOrgIdField ? subOrgIdField.options : [],
        v_required: { value: false, err: 'Select team' },
      })
    }
    standardFields.push({
      key: 'source',
      type: 'radio',
      label: 'New Source',
      tip: 'Update the source of the contact',
      options: sourceField ? sourceField.options : [],
      v_required: { value: false, err: 'Select source' },
    })
    let currentPlacement = 'left'
    standardFields.forEach((field) => {
      field.placement = currentPlacement
      currentPlacement = currentPlacement === 'left' ? 'right' : 'left'
    })
    this.formDefinition = {
      steps: [
        {
          fields: [...standardFields]
        }
      ]
    }
    if (customFields && customFields.length > 0) {
      let customPlacement = 'left'
      customFields.forEach((field) => {
        this.formDefinition.steps[0].fields.push({
          ...field,
          advanced: true,
          placement: customPlacement,
          v_required: { value: false }
        })
        customPlacement = customPlacement === 'left' ? 'right' : 'left'
      })
    }
    this.formDefinition.formType = 'add'
    this.formDefinition.ctaButtonText = 'Update'
    this.formDefinition.title = Array.isArray(this.apiData.userIds) ? `Update ${this.apiData.userIds.length} ${this.apiData.userIds.length === 1 ? 'contact' : 'contacts'}` : 'Update contact'
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath2({
        ms: AppConfig.CDP_MS.ENDPOINT,
        paths: ['miscs', 'update-crm-contact-bulk'],
        queryParams: { orgId: this.orgId, ...AppHelper.getTeamApiParams(this.orgId, 'staffSubOrgId') }
      }),
      modalOpen: true
    });
  }

  static openModalForExport(items) {
    this.apiData = {
      orgId: this.orgId,
      userIds: Array.isArray(items) ? items.map(u => u.userId) : items.userId,
      _isMultiSelectExport: true,
    }
    this.formDefinition = {
      steps: [{fields: []}]
    }
    this.formDefinition.formType = 'add'
    this.formDefinition.ctaButtonText = 'Export'
    this.formDefinition.title = Array.isArray(this.apiData.userIds) ? `Export ${this.apiData.userIds.length} ${this.apiData.userIds.length === 1 ? 'contact' : 'contacts'}` : 'Export contact'
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath2({
        ms: AppConfig.CDP_MS.ENDPOINT,
        paths: ['miscs', 'export-crm-contact'],
        queryParams: { orgId: this.orgId, ...(AppHelper.isTeamsUnifiedView(this.orgId) ? AppHelper.getTeamApiParams(this.orgId) : {}) }
      }),
      modalOpen: true
    });
  }

  static openModalForExportAccounts(items) {
    this.apiData = {
      orgId: this.orgId,
      accountIds: Array.isArray(items) ? items.map(a => a.id) : [items.id],
      _isMultiSelectExport: true,
    }
    this.formDefinition = {
      steps: [{fields: []}]
    }
    this.formDefinition.formType = 'add'
    this.formDefinition.ctaButtonText = 'Export'
    const count = Array.isArray(this.apiData.accountIds) ? this.apiData.accountIds.length : 1
    this.formDefinition.title = `Export ${count} ${count === 1 ? 'account' : 'accounts'}`
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath2({
        ms: AppConfig.CDP_MS.ENDPOINT,
        paths: ['miscs', 'export-crm-account'],
        queryParams: { orgId: this.orgId }
      }),
      modalOpen: true
    });
  }

  static extractSettingsKey(current) {
    const keys = Object.keys(current).filter(k => k !== '__index')
    return keys.length ? keys[0] : ''
  }
  static extractSettingsValue(current) {
    const key = this.extractSettingsKey(current)
    return key ? current[key] : ''
  }
  static extractSettingsFields(current, fieldsAttrs) {
    const key = this.extractSettingsKey(current)
    return fieldsAttrs.filter(i => i.key === key)
  }
  static extractSettingsLabel(current, fieldsAttrs) {
    const fields = this.extractSettingsFields(current, fieldsAttrs)
    return fields.length ? fields[0].label : ''
  }
  static removeFields(fieldDef, keys) {
    const fieldDefCp = JSON.parse(JSON.stringify(fieldDef))
    fieldDefCp.steps[0].fields = fieldDefCp.steps[0].fields.filter(f => !keys.includes(f.key))
    return fieldDefCp
  }
  static reflowFields(fieldDef) {
    const fieldDefCp = JSON.parse(JSON.stringify(fieldDef))
    let dir = 'left'
    for (const f of fieldDefCp.steps[0].fields) {
      f.placement = dir
      dir = dir === 'left' ? 'right' : 'left'
    }
    return fieldDefCp
  }

  static reflowAdvancedFields(fieldDef) {
    const fieldDefCp = JSON.parse(JSON.stringify(fieldDef))
    const fields = fieldDefCp.steps[0].fields
    let dir = 'left'
    for (const f of fields) {
      if (!f.advanced) { continue }
      f.placement = dir
      dir = dir === 'left' ? 'right' : 'left'
    }
    return fieldDefCp
  }

  static removeOptions(field, keys) {
    if (!field || !Array.isArray(field.options) || !Array.isArray(keys)) { return field }
    field.options = field.options.filter(o => !keys.includes(o.key))
    return field
  }
  static removeHiddenCrmContactStates(field, orgId) {
    if (!field || !orgId) return
    const crmHiddenStatusesCdpSettings = AppHelper.getSetting(orgId, 'CRM_CONTACT_HIDE_STATUS')
    const hiddenStatuses = crmHiddenStatusesCdpSettings.split(',').map(item => item.trim()).filter(Boolean)
    return UiHelper.removeOptions(field, hiddenStatuses)
  }

  static getOrgTitle() {
    return Controller.get().roleHelper().getOrgUnitTitle()
  }

  static getMainOrgTitle() {
    return Controller.get().roleHelper().getMainOrgTitle()
  }

  static withLinkedOptions(field, optionsFieldDef) {
    if (!field || (Array.isArray(field.options) && field.options.length > 0)) {
      return field
    }
    const sourceKey = field._optionsField
    if (!sourceKey || !optionsFieldDef || !optionsFieldDef.steps || !optionsFieldDef.steps[0] || !Array.isArray(optionsFieldDef.steps[0].fields)) {
      return field
    }
    const source = Helper.getField(optionsFieldDef, sourceKey)
    if (!source || !Array.isArray(source.options) || source.options.length === 0) {
      return field
    }
    return { ...field, options: source.options }
  }

  static getReadableVal(key, field, values) {
    function _replace(val) {
      if (!field) { return val }
      if (field.type === 'radio' || field.type === 'check_box' || field.type === 'select') {
        if (!Array.isArray(field.options)) { return val }
        const newOption = field.options.find(o => o.key === val)
        return newOption ? newOption.label || newOption.title || newOption.text : val
      } else if (field.type === 'date_yyyymmdd') {
        return val ? moment(val).format('DD-MMM-YYYY') : ''
      } else if (field.type === 'dateTime') {
        return val ? Helper.formatTimestamp(Number.parseInt(val)) : val
      }
      return val
    }
    if (Array.isArray(values[key])) {
      const out = values[key].map(val => _replace(val))
      if (out.length === 0) { return 'NONE' }
      return out.join(', ')
    }
    return _replace(values[key]) || 'NONE'
  }

  static getTagKeysFromUpdateValue(val) {
    if (val === undefined || val === null || val === '') { return [] }
    if (Array.isArray(val)) { return val }
    return String(val).split(',').map(s => s.trim()).filter(Boolean)
  }

  static getTagLabelFromField(field, tagKey) {
    if (!field || !Array.isArray(field.options)) { return tagKey }
    const opt = field.options.find(o => o.key === tagKey)
    return opt ? (opt.label || opt.title || opt.text || tagKey) : tagKey
  }

  static getUpdateDiffSummary(current, fieldDef) {
    let summary = ''

    try {
      const newValues = current.payload.newObj || {}
      const previousValues = current.payload.oldObj || {}
      Object.keys(newValues).forEach(k => {
        const field = Helper.getField(fieldDef, k)
        if (!field) { return }
        const label = field.label || k
        if (k === 'tags') {
          const newTagKeys = UiHelper.getTagKeysFromUpdateValue(newValues[k])
          const oldTagKeys = UiHelper.getTagKeysFromUpdateValue(previousValues[k])
          const addedKeys = newTagKeys.filter(t => !oldTagKeys.includes(t))
          const removedKeys = oldTagKeys.filter(t => !newTagKeys.includes(t))
          if (addedKeys.length === 0 && removedKeys.length === 0) { return }
          if (addedKeys.length > 0) {
            const addedLabels = addedKeys.map(t => Helper.escapeHtml(String(UiHelper.getTagLabelFromField(field, t)))).join(', ')
            summary = summary + `<p>Tags Added: ${addedLabels}</p>`
          }
          if (removedKeys.length > 0) {
            const removedLabels = removedKeys.map(t => Helper.escapeHtml(String(UiHelper.getTagLabelFromField(field, t)))).join(', ')
            summary = summary + `<p>Tags Removed: ${removedLabels}</p>`
          }
          return
        }
        let newVal = UiHelper.getReadableVal(k, field, newValues) || newValues[k] || 'NONE'
        if (Array.isArray(newVal)) { newVal = newVal.join(', ')}
        let prevVal = UiHelper.getReadableVal(k, field, previousValues) || previousValues[k] || 'NONE'
        if (Array.isArray(prevVal)) { prevVal = prevVal.join(', ')}
        if (newVal === prevVal) { return }
        summary = summary + `<p>${label}: ${newVal} [previously ${prevVal}]</p>`
      })
    } catch (err) {
      console.log('getUpdateDiffSummary err: ', err)
    }
    return summary
  }

  static async openModalForClickToCall(current) {
    try {
      if(current && current.phone) {
        this.apiData = {
          orgId: this.orgId,
          ...AppHelper.getTeamBodyParams(this.orgId, 'staffSubOrgId'),
          staffUserId: this.staffUserId,
          userId: current.userId,
          contactId: current.id,
          _isClickToCall: true,
        }
        const apiEndPoint = ApiHelper.makeUrlPath2({
          ms: AppConfig.CDP_MS.ENDPOINT,
          paths: ['miscs', 'call-crm-contact'],
          queryParams: { orgId: this.orgId, ...(AppHelper.isTeamsUnifiedView(this.orgId) ? AppHelper.getTeamApiParams(this.orgId) : {}) }
        })

        const response = await ApiHelper.callAwait({
          method: 'POST',
          endPoint: apiEndPoint,
          jsonBody: {
            ...this.apiData,
            _preview: true,
          }
        })

        const {agentPhone, toPhone} = response
        let {agentPhoneNumbers} = response
        if (!agentPhoneNumbers) {
          if (agentPhone) { agentPhoneNumbers = [agentPhone] } else { agentPhoneNumbers = [] }
        }
        this.formDefinition = {
          steps: [
            {
              fields: [
                {
                  key: 'agentPhone',
                  type: 'radio',
                  label: 'Agent Number',
                  options: agentPhoneNumbers.map(apn => ({key:apn, label:apn})),
                  defaultValue: agentPhoneNumbers.length > 0 ? agentPhoneNumbers[0] : '',
                  v_required: { value: true, err: 'Select agent number' },
                  placement: 'left'
                },
                {
                  key: 'toPhone',
                  type: 'edit_text',
                  label: 'Contact Number',
                  defaultValue: toPhone,
                  v_required: { value: true, err: 'Select contact number' },
                  placement: 'right'
                },
              ]
            }
          ],
          disableAlwaysFormFields: ['toPhone'],
        }
        if (agentPhoneNumbers.length < 2) {
          this.formDefinition.disableAlwaysFormFields.push('agentPhone')
        }
        if (agentPhoneNumbers.length === 0) {
          this.formDefinition.description = Helper.getString('clickToCallNoPhoneNumberErrMsg')
          this.formDefinition.customStyles = {
            ...this.formDefinition.customStyles,
            modalDescriptionStyles: Styles.clickToCallNoPhoneNumberErrMsg
          }
        }

        this.formDefinition.formType = 'add'
        this.formDefinition.ctaButtonText = 'Confirm'
        this.formDefinition.title = `Place a call to ${Helper.formatName(current) || current.phone}`
        this.setState({
          apiMethod: 'POST',
          apiEndPoint,
          modalOpen: true
        });
      } else {
        this.setState({
          showToast: true,
          isErrorToast: true,
          toastMsg: 'Mobile Number Not Found'
        })
      }
    } catch (error) {
      this.setState({
        showToast: true,
        isErrorToast: true,
        toastMsg: Helper.getErrorMsg(error)
      })
    }
  }
  static async openModalForClickToWhatsApp(current, isApp = false) {
    let phone = ''
    if (current && current.phone) {
      phone = current.phone.trim()
    }
    phone = phone.startsWith('+') ? phone.slice(1) : phone
    const whatsappUrl = `${isApp ? 'whatsapp://' : 'https://api.whatsapp.com/'}send/?phone=${phone}`
    if (this.whatsappTab && !this.whatsappTab.closed) {
      // If tab is already open, focus or reload it
      this.whatsappTab.focus()
      this.whatsappTab.location.href = whatsappUrl // optional if you want to reload
    } else {
      // If not open yet, open a new one
      this.whatsappTab = window.open(whatsappUrl, 'slxWA')
    }

    await ApiHelper.trackContactStaffActivity(current, 'WHATSAPP DIRECT')
  }

  static buttonWithBadge(options) {
    return(
      <Badge badgeContent={(options.badgeContent || Number(options.badgeContent) === 0) ? options.badgeContent : ''} max={options.badgeMax || 100} color={options.badgeColor || 'primary'} overlap={options.badgeOverlap || 'circle'}>
        <AppButton
          buttonStyle={options.buttonStyle}
          buttonTextStyle={options.buttonTextStyle}
          iconContainerStyle={options.iconContainerStyle}
          iconStyle={options.iconStyle}
          onClick={options.onClickHandler}
          icon={options.icon}
        />
      </Badge>
    )
  }

  static renameCRMContactLeadStatus(orgId, status, showOriginal = false) {
    function parseLeadStatusMapping(input) {
      const result = {};

      if (!input || typeof input !== 'string') {
        return result;
      }

      const pairs = input.split(',');

      for (let i = 0; i < pairs.length; i++) {
        const pair = pairs[i].trim();
        if (!pair) continue;

        const colonIndex = pair.indexOf(':');
        if (colonIndex === -1) continue;

        const key = pair.slice(0, colonIndex).trim();
        const value = pair.slice(colonIndex + 1).trim();

        if (!key || !value) continue;

        result[key] = value;
      }

      return result;
    }

    const settings = AppHelper.getSetting(orgId,'CRM_CONTACT_LEAD_STATUS');

    if (!settings) return status;

    const forwardMap = parseLeadStatusMapping(settings);

    if (!forwardMap || Object.keys(forwardMap).length === 0) {
      return status;
    }

    const reverseMap = {};
    for (const key in forwardMap) {
      if (!reverseMap[forwardMap[key]]) {
        reverseMap[forwardMap[key]] = key;
      }
    }

    if (!showOriginal) {
      if (forwardMap[status]) {
        return forwardMap[status];
      }
      return status;
    }

    if (showOriginal) {
      if (reverseMap[status]) {
        return reverseMap[status];
      }
      return status;
    }

    return status;
  }

  static renameLeadStatusFieldOptions(field, orgId) {
    if (field && Array.isArray(field.options) && orgId) {
      field.options = field.options.map((option) => {
        if (option) {
          return {
            ...option,
            label: UiHelper.renameCRMContactLeadStatus(orgId, option.label)
          };
        }
        return option
      })
    }

    return field
  }

  static retrieveOptions(items = []) {
    const options = []
    for (const d of items) {
      options.push({
        key: d.id || d.userId,
        text: d.title || Helper.formatName(d)
      })
    }
    return options
  }
}

const Styles = StyleSheet.create({
  container: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
    height: '100vh',
  },
  container2: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
    flexDirection: 'column',
  },
  inPlaceContentLoadingViewContainer:{
    paddingTop: '10%',
    paddingBottom: '10%'
  },
  container2PageDialog: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100%',
  },
  loadingViewOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(0, 0, 0, 0.1)',
    zIndex: 9998,

  },
  transparentLoadingViewContainer: {
    position: 'fixed',
    top: '50%',
    left: '60%',
    transform: 'translate(-75%, -50%)',
    zIndex: 1000,
  },
  emptyContainer: {
    minHeight: '75vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 24,
    color: '#7D7D7D'
  },
  progress: {
    color: AppTheme.primaryColor
  },
  error: {
    textAlign: 'center',
    maxWidth: 500
  },
  errorContainer: {
    flex: 1,
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: AppTheme.primaryBg,
    flexDirection: 'column'
  },
  errImageContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 120,
    height: 120,
    backgroundColor: 'white',
    padding: 20,
    borderRadius: '50%'
  },
  image: {
    maxHeight: '100%',
    maxWidth: '100%'
  },
  nfMiddle: {
    fontSize: 20,
    color: 'white',
    fontWeight: 'bold',
    textAlign: 'center'
  },
  valueText: {
    fontSize: 16,
    color: '#000000'
  },
  spanContainer: {
    display: 'flex'
  },
  spanTextContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  spanImgContainer: {
    width: 40,
    height: 40,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12
  },
  imageContent: {
    height: '100%',
    width: '100%',
    borderRadius: 6,
    objectFit: 'cover'
  },
  slugSmContainer:{
    display:'flex',
    alignItems:'center',
    gap:5
  },
  itemValue: {
    fontSize: 16
  },
  line2: {
    fontSize: 12,
    color: 'grey'
  },
  statusOuterContainer: {
    display: 'flex'
  },
  statusTitle: {
    color: '#00CA6F',
    fontSize: 16,
    fontWeight: 500,
    margin: 0,
    marginRight: 18,
    textTransform: 'capitalize',
    minWidth: 80
  },
  statusTitleStyle: {
    color: '#222222',
  },
  countContainer: {
    display: 'flex'
  },
  countSecondContainer: {
    marginTop: 8
  },
  imageContainer: {
    width: 20,
    height: 20
  },
  statusValue: {
    fontSize: 16,
    color: '#7D7D7D',
    margin: 0,
    marginLeft: 8
  },
  customEmptyContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  customImageContainer: {
    marginTop: 80,
    width: 250 / 2,
    height: 162 / 2
  },
  customText: {
    color: '#7D7D7D',
    fontSize: 26,
    margin: 0,
    marginTop: 24,
    marginBottom: 24,
    '@media (max-width: 767px)': {
      fontSize: 16,
      textAlign: 'center'
    }
  },
  loaderContainer: {
    position: 'relative'
  },
  loaderImageContainer: {
    position: 'absolute',
    width: 39,
    height: 41,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    margin: 'auto'
  },
  actionMenuItem: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    cursor: 'pointer'
  },
  actionMenuText: {
    fontSize: 14,
    color: '#222222',
    margin: 0,
    marginRight: 10,
    flex: 1
  },
  transparentOuterContainer: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column'
  },
  checkBox1: {
    flex: 1,
    backgroundColor: '#fffffff'
  },
  checkBox2: {
    flex: 1,
    backgroundColor: '#f5f5f5'
  },
  transparentInnerContainer: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1
  },
  weekDaysContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 4,
    fontSize: 12,
    marginTop: 7,
    marginBottom: 7
  },
  dayCell: {
    minWidth: 25,
    minHeight: 5,
    padding: 2,
    textAlign: 'center'
  },
  normalDayCell: {
    border: '0.5px solid grey',
    borderRadius: 4,
    color: 'lightgrey',
  },
  activeDayCell: {
    border: '0.5px solid grey',
    borderRadius: 4,
    color: 'darkgrey',
    fontWeight: 'bold'
  },
  orderChangeBtnContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: 0,
    width: '100%',
    height: 46,
  },
  orderChangeBtn: {
    padding: 0,
    fontSize: 7,
  },
  orderChangeBtnDisabled: {
    padding: 0,
    fontSize: 7,
    color: 'gray',
  },
  orderText: {
    fontSize: 14,
    color: 'gray',
    minWidth: 24,
    textAlign: 'center'
  },
  iconContainerStyle: {
    border: 'unset',
  },
  tooltip: {
    zIndex: 9999999999
  },
  clickToCallNoPhoneNumberErrMsg: {
    color: '#ff0c0d'
  },
  accountEnrichCreditsNotice: {
    color: 'green',
  },
  enrichCreditsLearnMoreLink: {
    color: AppTheme.primaryColor,
    textDecoration: 'underline',
  },
})
